/* eslint-disable max-len */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css } from 'aphrodite';
import shortid from 'shortid';
import handleViewport from 'react-in-viewport';

import {
    display,
    position
} from '../../../../../../commonStyles.js';
import cardCommonStyles from '../cardCommonStyles.js';
import styles from './styles.js';

import { TranslationHelper } from '../../../../../../helpers';

import Translatable from '../../../../../../components/Translatable';
import WishlistHeart from './WishlistHeart';
import ImageCarouselNav from './ImageCarouselNav';
import BackgroundImage from './BackgroundImage';
import StarRating from './StarRating';
import CornerTriangle from './CornerTriangle';
import AdminButton from './AdminControls/AdminButton';
import AdminSwitch from './AdminControls/AdminSwitch';
import PlaceInner from './PlaceInner';
// import AdminTags from '../../../../../../components/AdminTags/AdminTags_Search.jsx';
// import AdminVerticalSelect from './AdminVerticalSelect';

class Card extends Component {
    static propTypes = {
        activeVerticalId: PropTypes.number,
        addAssetTag: PropTypes.func.isRequired,
        addImpressionEventToBatch: PropTypes.func,
        adminTags: PropTypes.array.isRequired,
        apiUrl: PropTypes.string.isRequired,
        card: PropTypes.object.isRequired,
        cardId: PropTypes.number.isRequired,
        cardPadding: PropTypes.number.isRequired,
        config: PropTypes.object.isRequired,
        currencySymbol: PropTypes.string.isRequired,
        domain: PropTypes.string.isRequired,
        highlightMapMarker: PropTypes.func.isRequired,
        inViewport: PropTypes.bool,
        isAdmin: PropTypes.bool,
        isLoggedIn: PropTypes.bool.isRequired,
        lang: PropTypes.object.isRequired,
        removeAssetTag: PropTypes.func.isRequired,
        sendClickEvent: PropTypes.func,
        sendImageCarouselEvent: PropTypes.func,
        setAdminImageControl: PropTypes.func,
        setAdminVenueControl: PropTypes.func,
        toggleAgreedToList: PropTypes.func.isRequired,
        toggleAssetImageFlag: PropTypes.func.isRequired,
        updateRoomVerticalChange: PropTypes.func.isRequired,
        updateTagRanking: PropTypes.func.isRequired,
        verticals: PropTypes.array.isRequired
    }

    static defaultProps = { isAdmin: false }

    state = {
        activeImageIndex: 0,
        images: this.props.card.images,
        isChangingImage: false
    }

    constructor(props) {
        super(props);
        this._isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints;
        this.translationHelper = new TranslationHelper({
            messages: this.props.lang
        });
    }

    componentDidMount() {
        $(`#result_${this.props.card.id}`).flip({
            trigger: 'manual'
        });
    }

    _impressionSent = false

    handleMouseEnter = () => {
        this.props.highlightMapMarker(this.props.card.id);
    }

    handleMouseLeave = () => {
        this.props.highlightMapMarker(null);
    }

    flipCard = () => {
        $(`#result_${this.props.card.id}`).flip('toggle');
    }

    setActiveImage = e => {
        this.setState({ isChangingImage: true });
        this.props.sendImageCarouselEvent(this.state.images[this.state.activeImageIndex]);
        let index = this.state.activeImageIndex;
        if (e.target.dataset.direction === 'next') {
            index += 1;
            if (index > (this.state.images.length - 1)) {
                index = 0;
            }
        } else if (e.target.dataset.direction === 'previous') {
            index -= 1;
            if (index < 0) {
                index = this.state.images.length - 1;
            }
        }
        this.setState({
            activeImageIndex: index
        }, () => {
            setTimeout(() => {
                this.setState({
                    isChangingImage: false
                });
            }, 10);
        });
    }

    handleClickEvent = e => {
        this.props.sendClickEvent({
            asset_id: e.target.dataset.assetId
        });
    }

    toggleAgreedToList = () => {
        this.props.toggleAgreedToList(
            this.props.card.venue_id,
            !this.props.card.venue_agreed_to_list
        );
    }

    toggleAssetImageFlag = () => {
        const imageId = this.props.card.images[this.state.activeImageIndex].id;
        const flagged = !this.props.card.images[this.state.activeImageIndex].flagged;
        this.props.toggleAssetImageFlag(
            this.props.config,
            this.props.card.asset_id,
            imageId,
            flagged
        );
    }

    render() {
        let activeImage;
        if (this.state.images && this.state.images[this.state.activeImageIndex]) {
            activeImage = this.state.images[this.state.activeImageIndex];
        }
        if (!this._impressionSent && this.props.inViewport) {
            this.props.addImpressionEventToBatch({
                data: {
                    asset_id: this.props.card.asset_id
                },
                type: 'impression'
            });
            this._impressionSent = true;
        }
        const hocusPocus = false;
        const dataImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAADCAIAAADUVFKvAAAAO0lEQVQIHQEwAM//AVaMo+ny9ub19/X5/P39/QGVmJERDg7y9ffe4eXy9fgBh2I0Gg8EAwQFCwsL8/b6AlYbs3x20IQAAAAASUVORK5CYII=';
        // const inWrongVertical = (this.props.card.vertical_id !== this.props.activeVerticalId);
        let props = {};
        if (!this._isTouchDevice) {
            props = {
                onMouseEnter: this.handleMouseEnter,
                onMouseLeave: this.handleMouseLeave
            };
        }
        const isMobile = window.matchMedia('(max-width: 743px)').matches;
        return (
            <div
                id={`result_${this.props.card.id}`}
                className="card"
                {...props}
            >
                <div className={`front ${css(styles.containerDiv)}`}>
                    <CornerTriangle
                        handleClick={this.flipCard}
                    />
                    <div
                        className={css(styles.container_fullWidth)}
                        style={{
                            paddingTop: `${this.props.cardPadding}%`,
                            backgroundImage: `url('${dataImage}')`,
                            backgroundSize: '100% 100%'
                        }}
                        // style={this.props.isAdmin ? {
                        //     paddingTop: `${this.props.cardPadding + 20}%`,
                        //     backgroundImage: `url('${dataImage}')`,
                        //     backgroundSize: '100% 100%'
                        // } : {
                        //     paddingTop: `${this.props.cardPadding}%`,
                        //     backgroundImage: `url('${dataImage}')`,
                        //     backgroundSize: '100% 100%'
                        // }}
                    >
                        <div className={css(styles.children)}>
                            <div className={css(styles.fullWidth_fullHeight)}>
                                <div className={css(position.relative, styles.fullWidth_fullHeight)}>
                                    {
                                        this.props.isLoggedIn && hocusPocus ?
                                            <WishlistHeart
                                                isFavourite={Boolean(this.props.card.room_favourite)}
                                                roomId={Number(this.props.card.id)}
                                            /> : null
                                    }
                                    <BackgroundImage
                                        image={activeImage}
                                        isUpdating={this.state.isChangingImage}
                                    >
                                        {
                                            this.props.isAdmin ?
                                                <div className={css(styles.switchContainer)}>
                                                    <div
                                                        style={{
                                                            clear: 'both'
                                                        }}
                                                    >
                                                        <AdminButton
                                                            key={shortid.generate()}
                                                            buttonClassName={`edit_venue_${this.props.card.venue_id}`}
                                                            buttonText="Edit venue"
                                                            controlId={this.props.card.id}
                                                            isLink
                                                            link={this.props.card.venue_edit_url}
                                                        />
                                                    </div>
                                                    <div
                                                        style={{
                                                            clear: 'both'
                                                        }}
                                                    >
                                                        <AdminSwitch
                                                            className="red"
                                                            handleClick={this.toggleAssetImageFlag}
                                                            isChecked={
                                                                (this.props.card.images &&
                                                                    this.props.card.images.find(
                                                                        image => Number(image.id) === Number(activeImage.id)
                                                                    )) ?
                                                                    (this.props.card.images.find(
                                                                        image => Number(image.id) === Number(activeImage.id)
                                                                    ).flagged) : false
                                                            }
                                                            switchLabel="Remove"
                                                        />
                                                        <AdminSwitch
                                                            handleClick={this.toggleAgreedToList}
                                                            isChecked={this.props.card.venue_agreed_to_list}
                                                            switchLabel="Agreed To List"
                                                        />
                                                    </div>
                                                </div> : null
                                        }
                                    </BackgroundImage>
                                </div>
                            </div>
                            <ImageCarouselNav
                                card={this.props.card}
                                domain={this.props.domain}
                                sendClickEvent={this.props.sendClickEvent}
                                setActiveImage={this.setActiveImage}
                                slideshow={this.props.card.images.length > 1}
                            />
                        </div>
                    </div>
                    <div
                        style={{
                            marginTop: '8px'
                        }}
                    >
                        <div className={css(styles.twoLineTitle)}>
                            <a
                                className={css(styles.linkContainer)}
                                href={`/${this.props.domain}${this.props.card.url}`}
                                onClick={this.handleClickEvent}
                                rel="noopener noreferrer"
                                {...(!isMobile ? { target: '_blank' } : {})}
                            >
                                <div className={css(styles.roomInfoContainer, styles.roomInfoContainer_left)}>
                                    {
                                        this.props.card.sponsored ?
                                            <span className={css(styles.adBadge)}>
                                                Ad
                                            </span> : null
                                    }
                                    <span
                                        className={css(
                                            cardCommonStyles.text,
                                            cardCommonStyles.size_small,
                                            cardCommonStyles.weight_bold,
                                            display.inline,
                                        )}
                                        style={{
                                            whiteSpace: 'nowrap'
                                        }}
                                    >
                                        {
                                            (this.props.card.title && this.props.card.title.length) > 25 ?
                                                `${this.props.card.title.slice(0, 22)}...` : this.props.card.title
                                        }
                                    </span>
                                    <br />
                                    <span
                                        className={css(
                                            cardCommonStyles.text,
                                            cardCommonStyles.size_small,
                                            cardCommonStyles.weight_light,
                                            display.inline
                                        )}
                                    >
                                        {(this.props.card.max_capacity > 0) ? this.props.card.max_capacity_string : null}
                                    </span>
                                </div>
                                <div
                                    className={css(styles.roomInfoContainer, styles.roomInfoContainer_right)}
                                    style={{ textAlign: 'right' }}
                                >
                                    {
                                        this.props.card.hourly_rate ?
                                            <span
                                                className={css(
                                                    cardCommonStyles.text,
                                                    cardCommonStyles.size_small,
                                                    cardCommonStyles.weight_bold,
                                                    display.inline
                                                )}
                                            >
                                                <span dangerouslySetInnerHTML={{ __html: this.props.currencySymbol }} />{
                                                    Number(this.props.card.hourly_rate) < 100 ? Number(this.props.card.hourly_rate).toFixed(2) : Number(this.props.card.hourly_rate)
                                                }
                                                <Translatable
                                                    content={{
                                                        transKey: 'common.hour_per'
                                                    }}
                                                />
                                            </span> : null
                                    }
                                    {
                                        this.props.card.hourly_rate && this.props.card.daily_rate ? <br /> : null
                                    }
                                    {
                                        this.props.card.daily_rate ?
                                            <span
                                                className={css(
                                                    cardCommonStyles.text,
                                                    cardCommonStyles.size_small,
                                                    cardCommonStyles.weight_bold,
                                                    display.inline
                                                )}
                                            >
                                                <span dangerouslySetInnerHTML={{ __html: this.props.currencySymbol }} />{
                                                    Number(this.props.card.daily_rate) < 100 ? Number(this.props.card.daily_rate).toFixed(2) : Number(this.props.card.daily_rate)
                                                } / {this.translationHelper.choice('common.day_lower', 1)}
                                            </span> : null
                                    }
                                    {
                                        (this.props.card.hourly_rate || this.props.card.daily_rate) && this.props.card.monthly_rate ? <br /> : null
                                    }
                                    {
                                        this.props.card.monthly_rate ?
                                            <span
                                                className={css(
                                                    cardCommonStyles.text,
                                                    cardCommonStyles.size_small,
                                                    cardCommonStyles.weight_bold,
                                                    display.inline
                                                )}
                                            >
                                                <span dangerouslySetInnerHTML={{ __html: this.props.currencySymbol }} />{
                                                    Number(this.props.card.monthly_rate) < 100 ? Number(this.props.card.monthly_rate).toFixed(2) : Number(this.props.card.monthly_rate)
                                                } / {this.translationHelper.choice('common.month_lower', 1)}
                                            </span> : null
                                    }
                                </div>
                            </a>
                        </div>
                    </div>
                    <div className={css(styles.reviewPlace)}>
                        <div className={css(styles.reviewInner)}>
                            <a
                                className={css(styles.linkContainer)}
                                href={`/${this.props.domain}/venues/${this.props.card.venue_id}#reviews_link`}
                                onClick={this.handleClickEvent}
                                rel="noopener noreferrer"
                                {...(!isMobile ? { target: '_blank' } : {})}
                            >
                                {
                                    Number(this.props.card.review_count) > 0 ?
                                        <StarRating
                                            reviewCount={Number(this.props.card.review_count)}
                                            reviewCountString={this.props.card.review_count_string}
                                            reviewScore={Number(this.props.card.review_score)}
                                        /> : null
                                }
                            </a>
                        </div>
                        <div className={css(styles.placeInner)}>
                            {(this.props.card.venue_nearby_places !== null) && (
                                <PlaceInner place={this.props.card.venue_nearby_places.collection[0]} />
                            )}
                        </div>
                    </div>
                    {/* {
                        this.props.isAdmin ?
                            <div {...(inWrongVertical ? { className: css(styles.wrongVertical) } : {})}>
                                <div className={css(styles.verticalWrapper)}>
                                    <div className={css(styles.vertical)}>
                                        {this.props.card.vertical}
                                    </div>
                                    <div>
                                        <AdminVerticalSelect
                                            assetId={this.props.card.asset_id}
                                            selectedVertical={this.props.card.vertical_change_id}
                                            updateRoomVerticalChange={this.props.updateRoomVerticalChange}
                                            verticals={this.props.verticals}
                                        />
                                    </div>
                                </div>
                                <AdminTags
                                    addAssetTag={this.props.addAssetTag}
                                    adminTags={this.props.adminTags}
                                    assetId={this.props.card.asset_id}
                                    removeAssetTag={this.props.removeAssetTag}
                                    tags={this.props.card.tags}
                                    updateTagRanking={this.props.updateTagRanking}
                                    verticalId={this.props.card.vertical_id}
                                />
                            </div> : null
                    } */}
                </div>
                <div
                    className={`back ${css(styles.back)} ${css(styles.containerDiv)}`}
                    style={{ backfaceVisibility: 'hidden' }}
                >
                    <CornerTriangle
                        handleClick={this.flipCard}
                        isBack
                    />
                    <div
                        className={css(styles.container_fullWidth)}
                        style={{
                            paddingTop: `${this.props.cardPadding + 20}%`,
                            backgroundSize: '100% 100%'
                        }}
                        // style={this.props.isAdmin ? {
                        //     paddingTop: `${this.props.cardPadding + 80}%`,
                        //     backgroundSize: '100% 100%'
                        // } : {
                        //     paddingTop: `${this.props.cardPadding + 20}%`,
                        //     backgroundSize: '100% 100%'
                        // }}
                    >
                        <div
                            style={{
                                position: 'absolute',
                                top: 0,
                                right: 0,
                                bottom: 0,
                                left: 0
                            }}
                        >
                            <a
                                href={`/${this.props.domain}${this.props.card.url}`}
                                onClick={this.handleClickEvent}
                                rel="noopener noreferrer"
                                title={this.props.card.title}
                                {...(!isMobile ? { target: '_blank' } : {})}
                            >
                                <h4
                                    style={{
                                        overflow: 'hidden',
                                        whiteSpace: 'nowrap',
                                        maxWidth: '90%'
                                    }}
                                >
                                    {this.props.card.title}
                                </h4>
                                <p>
                                    {this.props.card.venue_name}
                                </p>
                            </a>
                            <p
                                style={{
                                    display: '-webkit-box',
                                    maxWidth: '285px',
                                    height: '155px',
                                    margin: '0 auto',
                                    WebkitLineClamp: 7,
                                    WebkitBoxOrient: 'vertical',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                }}
                                dangerouslySetInnerHTML={{ __html: this.props.card.desc }}
                            />
                            <center>
                                <a
                                    className="btn btn-sm btn-primary"
                                    href={`/${this.props.domain}${this.props.card.url}`}
                                    onClick={this.handleClickEvent}
                                    rel="noopener noreferrer"
                                    style={{
                                        marginTop: '15px'
                                    }}
                                    {...(!isMobile ? { target: '_blank' } : {})}
                                >
                                    <Translatable
                                        content={{
                                            transKey: 'common.book_now'
                                        }}
                                    />
                                </a>
                            </center>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default handleViewport(Card);



// WEBPACK FOOTER //
// ./src/pages/Search/Main/CardSlider/CardContainer/Card/Card.jsx